module.exports = __webpack_public_path__ + "media/bootstrap-icons/bag-x-7f2c7e02.svg";